import React from 'react';
import styled from 'styled-components';

const NavContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  z-index: 1000;
  box-shadow: var(--shadow-card);
`;

const NavContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 200px;
`;

const LogoImage = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

const LogoText = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-primary);
  font-family: 'Quicksand', sans-serif;
  white-space: nowrap;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 2rem;
  margin-left: auto;
`;

const NavLink = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  color: ${props => props.$active ? 'var(--color-primary)' : 'var(--color-text)'};
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  font-family: 'Quicksand', sans-serif;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    background-color: var(--color-primary);
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover {
    color: var(--color-primary);
    &::after {
      width: 100%;
    }
  }

  ${props => props.$active && `
    &::after {
      width: 100%;
    }
  `}
`;

interface NavbarProps {
  currentSection: string;
  onSectionChange: (section: string) => void;
  isVisible: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ currentSection, onSectionChange, isVisible }) => {
  if (!isVisible) return null;

  const sections = [
    { id: 'accueil', label: 'Accueil' },
    { id: 'psychomotricite', label: 'La Psychomotricité' },
    { id: 'galerie', label: 'Galerie' },
    { id: 'equipe', label: 'L\'équipe' },
    { id: 'liens', label: 'Liens' }
  ];

  return (
    <NavContainer>
      <NavContent>
        <Logo>
          <LogoImage src="/assets/images/logo.png" alt="Logo L'arcade de l'Hêtre" />
          <LogoText>L'arcade de l'Hêtre</LogoText>
        </Logo>
        <NavLinks>
          {sections.map(section => (
            <NavLink
              key={section.id}
              $active={currentSection === section.id}
              onClick={() => onSectionChange(section.id)}
            >
              {section.label}
            </NavLink>
          ))}
        </NavLinks>
      </NavContent>
    </NavContainer>
  );
};

export default Navbar;
